export default __webpack_public_path__ + "static/media/icon-aggregator.9381ed64.svg";